import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { xeroQueryKeys } from "./xeroQueryKeys";

export const useQueryXeroGetAccountMappingOptionList = ({
  api,
}: {
  api: ApiType;
}) =>
  useQuery({
    queryKey: xeroQueryKeys.getAccountMappingOptionList(),
    queryFn: async () => (await api.xeroApi.getAccountMappingOptionList()).data,
  });
